<template>
    <div class="empty-result">
        <img :src="require('@/assets/query-service/no-content.svg')" alt="" />

        <div class="desc">
            <span> 1.您所输入的委托单编号有误。 </span>
            <span>
                2.若核实无误，请您耐心等待，数据、图片正在更新中，一般更新时间为15-20天。由于本系统的查询量较大，有部分查询可能会出现没有相关资料的信息，此时烦请您在线留言工作人员帮你查询,本中心对委托查询系统具有最终解释权。
            </span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.empty-result {
    margin: 64px 0 16px;
    img {
        display: block;
        margin: 0 auto;
    }
    .desc {
        width: 560px;
        font-size: 12px;
        color: #999999;
        line-height: 20px;
        margin: 0 auto;
        span {
            display: block;
        }
    }
}
</style>
